import { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import axios from 'axios';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import DataLoader from '../../../Utils/DataLoader';

export default function HomeAllInclusive() {
    const [allinclusiveData, setAllinclusiveData] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);

    const homeallInclusiveResorts = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}home-groupon-data?limit=30`
            );
            setAllinclusiveData(response?.data?.data || []);
        } catch (err) {
            console.log("Resort API error:", err);
        }
    };
    useEffect(() => {
        async function loadAllData() {
            try {
                await Promise.all([
                    homeallInclusiveResorts()
                ]);
            } catch (err) {
                console.log("Page loading error:", err);
            } finally {
                setPageLoading(false);
            }
        }

        loadAllData();
    }, []);

    if (pageLoading) {
        return <DataLoader />;  // Full screen loader
    }

    return (
        <section className="section-equal-padding">
            <div className="container-fluid">
                <div className="section-top-heading text-center mb-md-5 mb-3">
                    <h2 className="text-black">All-Inclusive Resorts</h2>
                    <p>
                        Get set for an incredible journey with our All-Inclusive Resort Discounts!...
                    </p>
                </div>

                {allinclusiveData?.length > 0 ? (
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        spaceBetween={20}
                        loop={true}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        navigation={true}
                        breakpoints={{
                            0: { slidesPerView: 1 },
                            768: { slidesPerView: 2 },
                            992: { slidesPerView: 3 },
                            1400: { slidesPerView: 4 },
                        }}
                        className="excitement-swiper pb-70"
                    >


                        {allinclusiveData.map((ele) => (
                            <SwiperSlide key={ele.id} className="">
                                <div className="card-item">
                                    <div className="resorts-box p-3 bg-white">

                                        <figure>
                                            <a href={ele.link} target="_blank" rel="noreferrer">
                                                <img loading="lazy" src={ele.imageLink} alt="" />
                                            </a>
                                        </figure>

                                        <div className="resort-description">

                                            {/* <div className='text-end'>
                                                        <span className="off-span">20% Off</span>
                                                    </div> */}

                                            {/* Discount Badge */}
                                            {ele?.salePrice?.amount && (
                                                <span className="off-span">
                                                    {Math.round(
                                                        ((ele.price.amount - ele.salePrice.amount) /
                                                            ele.price.amount) *
                                                        100
                                                    )}
                                                    % Off
                                                </span>
                                            )}
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={<Tooltip>{ele.title}</Tooltip>}
                                            >
                                                <h3 className="allInsTitle">
                                                    {ele.title.length > 35
                                                        ? ele.title.slice(0, 33) + "..."
                                                        : ele.title}
                                                </h3>
                                            </OverlayTrigger>
                                            <p>{ele.description?.slice(0, 60) + "..."}</p>
                                        </div>
                                        <div className="d-flex justify-content-between mt-auto">
                                            {/* <div className="price-label">
                                                        {ele?.salePrice?.amount ? (
                                                            <>
                                                                ${ele.salePrice.amount}{" "}
                                                                <span>${ele.price.amount}</span>
                                                            </>
                                                        ) : (
                                                            <>${ele.price.amount}</>
                                                        )}
                                                    </div> */}
                                            <div className="price-label">
                                                {ele?.salePrice?.amount ? (
                                                    <>
                                                        ${ele.salePrice.amount}{" "}
                                                        <span>${ele.price.amount}</span>
                                                    </>
                                                ) : (
                                                    <>${ele.price.amount}</>
                                                )}
                                                {/* <span>$329.00</span> */}
                                            </div>
                                            <div className="book-trip-btn">
                                                <a href={ele.link} target="_blank" rel="noreferrer" style={{ flexDirection: "row", }}>
                                                    Book Trip <i className="fa-solid fa-arrow-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <p>No Resorts Available</p>
                )}
            </div>
        </section>
    )
}
